import { Injectable, inject } from "@angular/core";
import { APP_CONFIG } from "app.config";
import { GraphQLService } from "app/shared/common/utils/graphql/graphql.service";
import { HttpHelper } from "app/shared/common/utils/http/HttpHelper";
import { Observable, forkJoin, from, map, of } from "rxjs";
import {
  // convertToHasuraFormat,
  // mutationUpdatePosting,
  // mutationUpdatePostingChannel,
  // queryInsertPostingChannel,
  // queryInsertPostRequisition,
  // queryInsertPostRequisitionJob,
  // queryInsertXConnectPosting
} from "./post.const";
import { UtilCommon } from "app/shared/common/utils/UtilCommon";
import { ACT_LOG_ACTION } from "app/shared/common/utils/graphql/graphql.constant";
import { CLASSIFICATION } from "../workflow-task.constant";
import { STATUS_IN_DATABASE } from "app/shared/common/constants/Status.constant";
import { GRAPHQL_QUERY } from "app/shared/common/utils/graphql/graphql.query.constant";
import { GRAPHQL_MUTATION } from "app/shared/common/utils/graphql/graphql.mutation.constant";
import { LocalityKeyEnum } from "../../recruit/candidate/constants";

@Injectable({ providedIn: "root" })
export class PostService {
  #graphQLService: GraphQLService = inject(GraphQLService);
  #httpHelper: HttpHelper = inject(HttpHelper);

  getPostResolver(): Observable<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, tatm_classification: { code: { _eq: CLASSIFICATION.FAMILY } } };
    const where1 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, tatm_classification: { code: { _eq: CLASSIFICATION.GROUP } } };
    const where2 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const where3 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const where4 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const where5 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const where6 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const where7 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, pltm_locality_type: { code: { _eq: LocalityKeyEnum.PROVINCE } } };
    const where8 = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, isPersonalLevelFlg: { _eq: 1 } };
    const query = GRAPHQL_QUERY.hrmQueryPostResolver.query;
    return from(
      this.#graphQLService.mutatePromiseWithVariable(query, {
        where, where1, where2, where3, where4, where5, where6, where7, where8
      })).pipe(map((data: any) => data || {}));
  }

  getAllJobFamily(): Observable<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, tatm_classification: { code: { _eq: CLASSIFICATION.FAMILY } } };
    const query = GRAPHQL_QUERY.hrmQueryTatbJobWhere.query;
    return from(
      this.#graphQLService.mutatePromiseWithVariable(query, {
        where
      })).pipe(map((data: any) => data?.data || []));
  }

  getAllSkill(): Observable<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const query = GRAPHQL_QUERY.hrmQueryTatmSkillWhere.query;
    return from(
      this.#graphQLService.mutatePromiseWithVariable(query, {
        where
      })).pipe(map((data: any) => data?.data || []));
  }

  getAllType(): Observable<any> {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const query = GRAPHQL_QUERY.hrmQueryTatmTypeWhere.query;
    return from(
      this.#graphQLService.mutatePromiseWithVariable(query, {
        where
      })).pipe(map((data: any) => data?.data || []));
  }

  getAllJobGroup() {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, tatm_classification: { code: { _eq: CLASSIFICATION.GROUP } } };
    const query = GRAPHQL_QUERY.hrmQueryTatbJobWhere.query;
    return from(
      this.#graphQLService.mutatePromiseWithVariable(query, {
        where
      })).pipe(map((data: any) => data?.data || []));
  }

  getCampaignsChannel(campaignId: number) {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, campaign_id: { _eq: campaignId } };
    const query = GRAPHQL_QUERY.hrmQueryRstbCampaignChannelWhere.query;
    return from(this.#graphQLService.mutatePromiseWithVariable(query, {
      where
    })).pipe(
      map((data: any) => data.data)
    );
  }

  getCampaignsStakeholder(campaignId: number, involedUnitCode: string) {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE }, campaign_id: { _eq: campaignId }, involved_unit_code: { _eq: involedUnitCode } };
    const query = GRAPHQL_QUERY.hrmQueryRstbCampaignStakeholderWhere.query;
    return from(this.#graphQLService.mutatePromiseWithVariable(query, {
      where
    })).pipe(
      map((data: any) => data.data)
    );
  }

  getChannels() {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const query = GRAPHQL_QUERY.hrmQueryRstmChannelWhere.query;
    return from(this.#graphQLService.mutatePromiseWithVariable(query, {
      where
    })).pipe(
      map((data: any) => data.data)
    );
  }

  getProductGroups() {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const query = GRAPHQL_QUERY.hrmQueryHrtmProductGroupWhere.query;
    return from(this.#graphQLService.mutatePromiseWithVariable(query, {
      where
    })).pipe(
      map((data: any) => data.data)
    );
  }

  getDetailRequisition(requisitionId: number) {
    // const where = { id: { _eq: requisitionId } }
    const _eq = requisitionId;
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionForPostingFormWhere.query;
    return from(this.#graphQLService.mutatePromiseWithVariable(query, {
      _eq
    })).pipe(
      map((data: any) => {
        return data.data;
      })
    );
  }

  getDetailRequisitionFull(requisitionId: number) {
    // const where = { id: { _eq: requisitionId } };
    const _eq = requisitionId;
    const query = GRAPHQL_QUERY.hrmQueryRstbRequisitionForPostingWhere.query;
    return from(
      this.#graphQLService.mutatePromiseWithVariable(query, {
        _eq
      })
    ).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  public savePostJob(data: any) {
    return of(data);
  }

  getPostByCode(postCode: string) {
    const where = { code: { _eq: postCode } };
    const query = GRAPHQL_QUERY.hrmQueryCstbPostingWhere.query;
    return from(this.#graphQLService.mutatePromiseWithVariable(query, {
      where
    })).pipe(
      map((data: any) => data?.data)
    );
  }

  getUserChannels() {
    const where = { recordStatus: { _eq: STATUS_IN_DATABASE.ACTIVE } };
    const query = GRAPHQL_QUERY.hrmQueryCstmChannelWhere.query;
    return from(this.#graphQLService.mutatePromiseWithVariable(query, {
      where
    })).pipe(
      map((data: any) => data.data)
    );
  }

  getPostChannels(postingId: number) {
    const where = { postingId: { _eq: postingId } };
    const query = GRAPHQL_QUERY.hrmQueryCstbPostingChannelWhere.query;
    return from(this.#graphQLService.mutatePromiseWithVariable(query, {
      where
    })).pipe(
      map((data: any) => data.data?.map((item: any) => {
        let object = {
          id: item?.channelId,
          code: item?.channel?.code,
          aggId: item?.aggId,
          name: item?.channel?.name,
          description: item?.channel?.description,
        };
        return object;
      }))
    );
  }

  // insertPostRequisition(request: any) {
  //   let { objects } = convertToHasuraFormat(request);
  //   delete objects["rstb_requisition_jobs"];
  //   return from(
  //     this.#graphQLService.mutatePromiseWithVariable(queryInsertPostRequisition, {
  //       objects,
  //     })
  //   );
  // }

  // insertPostRequisitionJob(request: any) {
  //   return from(
  //     this.#graphQLService.mutatePromiseWithVariable(queryInsertPostRequisitionJob, {
  //       objects: request,
  //     })
  //   );
  // }

  createCstbPosting(objects: any) {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_POSTING_JOB);
    // let { objects } = convertToHasuraFormat(request);
    const query = GRAPHQL_MUTATION.hrmInsertConnectCstbPosting.query;
    return from(this.#graphQLService.mutatePromiseWithVariable(query, {
      objects
    })).pipe(
      map((data: any) => data?.data?.returning?.[0])
    )
  }

  updateCstbPosting(inputPayload: { aggId: string, _set: any }) {
    UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_POSTING_JOB);
    const _eq = inputPayload.aggId;
    const _set = inputPayload._set;
    const query = GRAPHQL_MUTATION.hrmUpdateConnectCstbPosting.query;
    return from(this.#graphQLService.mutatePromiseWithVariable(query, {
      _eq, _set
    }))
  }

  // mutationUpdatePostingChannel(inputPayload: { aggId: string, _set: any }) {
  //   return from(
  //     this.#graphQLService.mutatePromiseWithVariable(
  //       mutationUpdatePostingChannel(inputPayload.aggId),
  //       {
  //         _set: inputPayload._set,
  //       }
  //     )
  //   );
  // }

  createCstbPostingChannel(objects: any) {
    const query = GRAPHQL_MUTATION.hrmInsertConnectCstbPostingChannel.query;
    return from(
      this.#graphQLService.mutatePromiseWithVariable(query, {
        objects
      }))
  }

  deleteCstbPostingChannelList(items: any[]) {
    return forkJoin(items.map((item) => this.deleteCstbPostingChannel(item.aggId)))
  }

  deleteCstbPostingChannel(_eq: string) {
    // const query = `mutation XHuntMutationDeleteConnectPostingChannel {
    //   data: delete_connect_cstb_posting_channel(where: {aggId: {_eq: "${aggId}"}}) {
    //     affected_rows
    //   }
    // }`;
    const query = GRAPHQL_MUTATION.hrmDeleteConnectCstbPostingChannel.query;
    return from(
      this.#graphQLService.mutatePromiseWithVariable(query, { _eq })).pipe(
        map((data: any) => data?.data))
  }

  // updateSlugPosting(id: number, slug: string) {
  //   UtilCommon.setGraphqlAction(ACT_LOG_ACTION.RECRUITMENT_POSTING_JOB);
  //   const query = `mutation XHuntMutationUpdateConnectPosting {
  //     data: update_connect_cstb_posting(where: {id: {_eq: "${id}"}}, _set: {slug: "${slug}"}) {
  //       affected_rows
  //     }
  //   }
  //   `;

  //   return from(this.#graphQLService.mutatePromise(query)).pipe(
  //     map((data: any) => data?.data)
  //   );
  // }

  exportPostJob(postingId: number, language: string) {
    const URL = `${APP_CONFIG.MCRHRRCRT}posting/printPosting`;
    return this.#httpHelper.methodPostObservableService(URL, {
      postingId,
      language
    })
  }

  queryActLog(code: any): Promise<any> {
    const where = { code: { _eq: code } };
    const query = GRAPHQL_QUERY.hrmQueryCstbPostingWhere.query;
    return this.#graphQLService.mutatePromiseWithVariable(query, {
      where
    });
  }
}
